<template>
  <div class="chat-widget-radio">
    <div
      v-for="option in options"
      :key="option.value"
      class="chat-widget-radio__option"
      :class="{
        'chat-widget-radio__option--selected': selectedValue === option.value,
        'chat-widget-radio__option--disabled': disabled,
      }"
      @click="!disabled && selectOption(option.value)"
    >
      <input
        type="radio"
        :checked="selectedValue === option.value"
        :disabled="disabled"
        class="mr-2"
      >
      <span>{{ option.label }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AIChatWidgetRadio',
  props: {
    options: {
      type: Array,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [String],
      default: null,
    },
  },
  data() {
    return {
      selectedValue: this.value || (this.options.length ? this.options[0].value : null),
    };
  },
  watch: {
    value(newVal) {
      this.selectedValue = newVal;
    },
  },
  methods: {
    selectOption(value) {
      this.selectedValue = value;
      this.$emit('select', value);
    },
  },
};
</script>

<style lang="scss" scoped>
.chat-widget-radio {
  display: flex;
  flex-direction: column;
  gap: 6px;

  &__option {
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: 6px 10px;
    border-radius: 6px;
    background-color: #fff;
    border: 1px solid #e2e8f0;
    font-size: 13px;
    transition: background-color 0.15s, border-color 0.15s;

    &:hover:not(.chat-widget-radio__option--disabled) {
      background-color: #f8fafc;
      border-color: #cbd5e1;
    }

    &--selected {
      border-color: #379C75;
      background-color: #EEF8F5;
    }

    &--disabled {
      opacity: 0.6;
      pointer-events: none;
    }

    input[type="radio"] {
      cursor: pointer;
      accent-color: #379C75;
    }
  }
}
</style>
